import * as React from 'react';
import * as ReactDom from 'react-dom';
import {
    LatestArticlesComponent,
    TemplatesList,
    PackageRelation,
    SubjectRelation,
    TagList
} from './Components';
import { TagHolderTypes, Payload } from './Model/core';
import { SearchResult, SearchContainer } from './Components/FKSearch';
import { renderInto } from './Components/CourseMatrix/main';
import { Search } from './Components/Search';
interface LatestArticlesProps {
    itemsToTake: number;
    mainArticleIds: string;
    shouldHideMainArticles: boolean;
    scrollToElement: Element | null;
    fetchChildren: boolean;
    currentPageId: number;
    apiEndpoint: string;
    childrenOf: number;
    allowedTagIds: string;
    containerId: string;
}
function getElement(element: Element | string | null) {
    const elm = typeof element === 'string' ? document.querySelector(element) : element;

    if (!elm) {
        throw 'No element to render into';
    }
    return elm;
}
function triggerLoaded() {
    const event = document.createEvent('Event');
    event.initEvent('blinfoLoaded', false, false);
    document.dispatchEvent(event);
}

function App({ itemsToTake, mainArticleIds, shouldHideMainArticles, scrollToElement, fetchChildren, currentPageId, apiEndpoint, childrenOf, allowedTagIds, containerId }: LatestArticlesProps) {
    return (
        <LatestArticlesComponent
            itemsToTake={itemsToTake}
            mainArticleIds={mainArticleIds}
            shouldHideMainArticles={shouldHideMainArticles}
            scrollToElement={scrollToElement}
            fetchChildren={fetchChildren}
            currentPageId={currentPageId}
            apiEndpoint={apiEndpoint}
            childrenOf={childrenOf}
            allowedTagIds={allowedTagIds}
            queryKey={containerId}
        />
    );
}

const blinfo = {
    intializeLatestArticles(
        element: Element | string,
        itemsToTake: number,
        mainArticleIds: string,
        shouldHideMainArticles: boolean,
        scrollToElement: Element | string,
        fetchChildren: boolean,
        currentPageId: number,
        apiEndpoint: string,
        childrenOf: number,
        allowedTagIds: string | null
    ) {
        const elm = typeof element === 'string' ? document.querySelector(element) : element;

        if (!elm) {
            throw 'No element to render into';
        }
        const scrollToElm: Element | null = typeof scrollToElement === 'string' ? document.querySelector(scrollToElement) : scrollToElement;

        ReactDom.render(
            <App
                itemsToTake={itemsToTake}
                mainArticleIds={mainArticleIds}
                shouldHideMainArticles={shouldHideMainArticles}
                scrollToElement={scrollToElm}
                fetchChildren={fetchChildren}
                currentPageId={currentPageId}
                apiEndpoint={apiEndpoint}
                childrenOf={childrenOf}
                allowedTagIds={allowedTagIds || ''}
                containerId={elm.id}
            />, elm);
    },
    initializeTemplatesList(element: Element | string, itemsPerPage: number, currentPageId: number, tagType: TagHolderTypes) {
        const elm = typeof element === 'string' ? document.querySelector(element) : element;
        if (!elm) {
            throw 'No element to render into';
        }

        ReactDom.render(<TemplatesList itemsPerPage={itemsPerPage} currentPageId={currentPageId} tagType={tagType} />, elm);
    },
    initializePackageRelation(element: Element | string, currentPageId: number, tagType: TagHolderTypes) {
        const elm = typeof element === 'string' ? document.querySelector(element) : element;
        if (!elm) {
            throw 'No element to render into';
        }

        ReactDom.render(<PackageRelation currentPageId={currentPageId} tagType={tagType} />, elm);
    },
    initializeSubjectRelation(element: Element | string, currentPageId: number, tagType: TagHolderTypes) {
        const elm = typeof element === 'string' ? document.querySelector(element) : element;
        if (!elm) {
            throw 'No element to render into';
        }

        ReactDom.render(<SubjectRelation currentPageId={currentPageId} tagType={tagType} />, elm);
    },
    initializeTagList(element: Element | string, showAllTags: string, tagType: TagHolderTypes) {
        const elm = typeof element === 'string' ? document.querySelector(element) : element;
        if (!elm) {
            throw 'No element to render into';
        }

        ReactDom.render(<TagList showAllTags={showAllTags} tagType={tagType} />, elm);
    },
    initializeFKSearch(
        SearchInputId: string,
        SearchResultId: string,
        apiEndpoint: string
    ) {
        SearchContainer({ SearchInputId, SearchResultId, apiEndpoint, customPlaceholder: null });
    },
    initializeBlogSearch(
        SearchInputId: string,
        SearchResultId: string,
        apiEndpoint: string
    ) {
        SearchContainer({ SearchInputId, SearchResultId, apiEndpoint, customPlaceholder: null });
    },
    initializeCourseMatrix(element: string, payloadData: Payload) {
        renderInto(element, payloadData);
    },
    initializeSearch(element: Element | string) {
        ReactDom.render(<Search />, getElement(element));
    }
}


const win = window as any;
win.ql.postload(function () {
    win.blinfo = blinfo;
    triggerLoaded();
});